import type { PeriodTypesRepositoryT } from "shared/domain/ports/periodTypes.repository";
import type {
  PeriodTypesApiT,
  PeriodTypesMapperT,
} from "../types/periodTypes.types";

import { extractErrorMessage } from "../../../utils/extractErrorMessage";

type PeriodTypesRepositoryParamsT = {
  periodTypesApi: PeriodTypesApiT;
  periodTypesMapper: PeriodTypesMapperT;
};

export const createPeriodTypesRepository = ({
  periodTypesApi,
  periodTypesMapper,
}: PeriodTypesRepositoryParamsT): PeriodTypesRepositoryT => ({
  getAll: async () => {
    try {
      const response = await periodTypesApi.getAll();

      if (response.status !== 200) {
        throw new Error("Ocurrió un error al obtener los tipos de periodo");
      }

      return periodTypesMapper.periodTypesDtoToDomain(response.data);
    } catch (error) {
      const message = extractErrorMessage(
        error,
        "Ocurrió un error al obtener los tipos de periodo",
      );

      throw new Error(message);
    }
  },

  import: async (periodTypeId) => {
    try {
      const response = await periodTypesApi.import({ periodTypeId });

      if (response.status !== 200) {
        throw new Error("Ocurrió un error al importar los tipos de periodo");
      }

      return periodTypesMapper.periodTypesDtoToDomain(response.data);
    } catch (error) {
      const message = extractErrorMessage(
        error,
        "Ocurrió un error al importar los tipos de periodo",
      );

      throw new Error(message);
    }
  },
});
